import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import Titulo from '../comum/Titulo';
import buscarRotas from '../../actions/rota/buscarRotas';
import excluirRotas from '../../actions/rota/excluirRota';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getOperadorRemarcacao,
    getGestorOperacoes,
    getVendedorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Rota from './Rota'
import ModalCadastrarRota from './ModalCadastrarRota';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarTrechos from '../../actions/trecho/buscarTrechos'
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import cadastrarRotaRetorno from '../../actions/rota/cadastrarRotaRetorno';
import ModalCadastroConexao from './ModalCadastroConexao';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import excluirConexao from '../../actions/rota/excluirConexao';
import selecionarConexao from '../../actions/rota/selecionarConexao';
import alterarExibicaoDetalhamentoRota from '../../actions/rota/alterarExibicaoDetalhamentoRota';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoRotas from './PaginacaoRotas';
import BotoesPaginacaoRotas from './BotoesPaginacaoRotas';
import PainelFiltragem from '../rota/PainelFiltrosRotas';
import determinarPaginaAtual from '../../actions/rota/determinarPaginaAtualRotas';
import alterarRegistrosPorPagina from '../../actions/rota/alterarRegistrosPorPaginaRotas';
import { showSuccessMsg } from '../../util/messagesUtil';
import ModalPrecosRota from './ModalPrecosRota';
import ModalImportarRotas from './ModalImportarRotas';
import importarRotas from '../../actions/rota/importarRotas';
import ModalHistoricoRota from './ModalHistoricoRota';
import $ from 'jquery';
import ModalAdicionarCidades from './ModalAdicionarCidades';
import buscarCidadesTrechosPorEmpresa from '../../actions/trecho/buscarCidadesTrechosPorEmpresa';

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--rota">
        <div className="vx-list-header-cell"></div>
        <div className="vx-list-header-cell">ID</div>
        <div className="vx-list-header-cell">Prefixo</div>
        <div className="vx-list-header-cell">Cidade origem</div>
        <div className="vx-list-header-cell">Cidade destino</div>
        <div className="vx-list-header-cell">Delimitação</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

const ModalConfirmacaoExclusaoRota = ({ excluir, rota }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoRota" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoExclusaoRota" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Excluir Rota
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir a rota{' '}
                        <strong>{rota && rota.cidadeOrigem ? `${rota.cidadeOrigem.nome} → ${rota.cidadeDestino.nome}` : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                        onClick={() => excluir()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const ModalTrechos = ({ rota }) => (
    <div className="modal fade" id="modalTrechos" tabIndex="-1" role="dialog"
        aria-labelledby="modalTrechos" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <i className="material-icons" style={{ fontSize: 16 }}>&#xe8d4;</i>
                        Trechos
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff' }}>
                    <strong>{rota && rota.trechosDto ? rota.trechosDto.map(t => t.cidadeDestino.nome).join(' -> ') : ''}</strong>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoExclusaoConexao = ({ excluir, conexao }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoConexao" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoExclusaoConexao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Excluir Conexão
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir a conexão{' '}
                        <strong>{conexao ? `${conexao.cidadeOrigem.nome} → ${conexao.cidadeDestino.nome}` : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                        onClick={() => excluir()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoCadastroRotaRetorno = ({ criar, rota }) => (
    <div className="modal fade" id="modalConfirmacaoCadastroRotaRetorno" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoCadastroRotaRetorno" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <i className="material-icons" style={{ fontSize: 16 }}>&#xe31b;</i>
                        Criar Rota de Retorno
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja criar a rota{' '}
                        <strong>{rota && rota.cidadeDestino ? `${rota.cidadeDestino.nomeComUf} → ${rota.cidadeOrigem.nomeComUf}` : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Não</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                        onClick={() => criar()}>
                        <i className="material-icons" style={{ fontSize: 15 }}>&#xe31b;</i>
                        Sim
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoImportacaoRotas = ({ importar, limpar }) => (
    <div className="modal fade" id="modalConfirmacaoImportacaoRotas" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoImportacaoRotas" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons" style={{ fontSize: 16 }}>cloud_upload</span>
                        Importar Rotas
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>Deseja importar as rotas selecionadas?</p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal" onClick={() => limpar()}>Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                        onClick={() => importar()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>cloud_upload</span>
                        Importar
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export class PainelGerenciarRotas extends React.Component {
    constructor(props) {
        super(props);
        props.selecionarRota(null);
        this.state = {
            callbackFecharModal: null,
            dadosImportacaoRotas: [],
            cidadesSelecionda: []
        }
    }

    preencherCidades(cidades) {
        this.setState({ cidadesSelecionda: cidades });
    }

    limparCidadesConexao() {
        this.setState({ cidadesSelecionda: [] });
    }

    buscarRotas() {
        this.props.buscarRotas(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    receberDadosDaImportacao(parametros) {
        this.setState({ dadosImportacaoRotas: parametros });
    }

    importarRotas() {
        this.props.importarRotas(this.props.empresaSelecionada.id, this.state.dadosImportacaoRotas)
            .then(() => {
                this.props.buscarRotas(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
                showSuccessMsg('Importação realizada.');
                this.fecharModalConfirmacaoImportacaoRotas();
                this.state.callbackFecharModal();
                this.limparDadosImportacaoRotas();
            });
    }

    fecharModalImportacaoRotas(callback) {
        this.setState({ callbackFecharModal: callback });
    }

    fecharModalConfirmacaoImportacaoRotas() {
        $('#modalConfirmacaoImportacaoRotas').modal('hide');
        $('#modalConfirmacaoImportacaoRotas').hide();
        $('.modal-backdrop').hide();
    }

    limparDadosImportacaoRotas() {
        this.setState({ dadosImportacaoRotas: [] });
    }

    excluir() {
        this.props.excluirRotas(this.props.rotaSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Rota excluída com sucesso');
                this.buscarRotas();
                this.props.selecionarRota(null);
            })
    }

    excluirConexao() {
        this.props.excluirConexao(this.props.conexaoSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Conexão excluída com sucesso');
                this.buscarRotas()
                    .then(() => {
                        this.props.alterarExibicaoDetalhamentoRota({ id: this.props.conexaoSelecionada.rotaId });
                        this.props.selecionarConexao(null);
                    });
            })
    }

    criarRotaRetorno() {
        this.props.cadastrarRotaRetorno(this.props.rotaSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Rota de retorno criada com sucesso');
                this.buscarRotas();
                this.props.selecionarRota(null);
            })
    }

    componentDidMount() {
        this.buscarRotas();
        this.props.buscarCidadesTrechosPorEmpresa(this.props.empresaSelecionada.id);
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarRotas();
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
            }
        }
    }

    limpar() {
        this.props.selecionarOrigem(null);
        this.props.selecionarDestino(null);
        this.props.selecionarRota(null);
    }

    exibirTabelaRotas() {
        if (this.props.rotas && this.props.rotas.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoRotas}
                        BotoesPaginacao={BotoesPaginacaoRotas}>
                        <CabecalhoTabela />
                        {this.exibirRotas()}
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">search</span>
                    <p>Nenhuma rota cadastrada para a empresa selecionada</p>
                </div>
            </div>
        );
    }

    exibirRotas() {
        return this.props.rotas
            .map((rota, index) => <Rota
                key={index} rota={rota} idEmpresa={this.props.empresaSelecionada.id} indice={index}
                preencherCidades={this.preencherCidades.bind(this)} />)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getOperadorRemarcacao(this.props.empresaSelecionada.id),
                getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Rotas" urlRetorno="/" />
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            <div className="col-12 conteudo-internas conteudo-painel area-btn-filtro-painel">
                                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                    <li className="nav-item dropdown nome-empresa">
                                        <div className="col-md-6">
                                            <CampoSelecionarEmpresa />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Autorizacao>
                        <div className="col-12 conteudo-internas conteudo-painel area-btn-filtro-painel">
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem />
                            </div>
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                getAdminEmpresa(this.props.empresaSelecionada.id),
                                getGestorEmpresa(this.props.empresaSelecionada.id),
                                getGestorOperacoes(this.props.empresaSelecionada.id),
                                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, margin: '12px 0' }}>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                        <button data-toggle="modal" data-target="#modalImportarRotas"
                                            className="vx-toolbar-btn vx-toolbar-btn--secondary"
                                            onClick={() => this.limpar()}>
                                            <span className="material-icons" style={{ fontSize: 16 }}>upload</span>
                                            Importar Rotas
                                        </button>
                                    </Autorizacao>
                                    <button data-toggle="modal" data-target="#modalCadastrarRota"
                                        className="vx-toolbar-btn"
                                        onClick={() => this.limpar()}>
                                        <span className="material-icons" style={{ fontSize: 16 }}>add</span>
                                        Nova Rota
                                    </button>
                                </div>
                            </Autorizacao>
                            {this.exibirTabelaRotas()}
                        </div>
                    </div>
                    <ModalCadastrarRota buscarRotas={this.buscarRotas.bind(this)} />
                    <ModalCadastroConexao />
                    <ModalConfirmacaoExclusaoRota excluir={this.excluir.bind(this)} rota={this.props.rotaSelecionada} />
                    <ModalConfirmacaoExclusaoConexao excluir={this.excluirConexao.bind(this)} conexao={this.props.conexaoSelecionada} />
                    <ModalConfirmacaoCadastroRotaRetorno criar={this.criarRotaRetorno.bind(this)} rota={this.props.rotaSelecionada} />
                    <ModalTrechos rota={this.props.rotaSelecionada} />
                    <ModalPrecosRota />
                    <ModalImportarRotas empresas={this.props.empresas} receberDadosDaImportacao={this.receberDadosDaImportacao.bind(this)} fecharModal={this.fecharModalImportacaoRotas.bind(this)} />
                    <ModalConfirmacaoImportacaoRotas importar={() => this.importarRotas()} limpar={() => this.fecharModalConfirmacaoImportacaoRotas()} />
                    <ModalHistoricoRota />
                    <ModalAdicionarCidades conexaoSelecionada={this.props.conexaoSelecionada} cidadesSelecionda={this.state.cidadesSelecionda}
                        preencherCidades={this.preencherCidades.bind(this)}
                        limparCidadesConexao={this.limparCidadesConexao.bind(this)}
                        buscarRotas={this.buscarRotas.bind(this)} />
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => ({
    empresas: state.empresas,
    rotas: state.rotas.rotas,
    changeFieldValue,
    empresaSelecionada: state.empresaSelecionada,
    trechos: state.trechos,
    rotaSelecionada: state.rotaSelecionada,
    conexaoSelecionada: state.conexaoSelecionada,
    paginaAtual: state.paginaAtualRota,
    registrosPorPagina: state.registrosPorPaginaRota,
    filtrosAdicionados: state.filtrosAdicionadosRota,
    cidadesTrechos: state.cidadesTrechos
});

export default connect(mapStateToProps, {
    buscarRotas,
    excluirRotas,
    buscarTrechos,
    cadastrarRotaRetorno,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
    excluirConexao,
    selecionarConexao,
    alterarExibicaoDetalhamentoRota,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    importarRotas,
    buscarCidadesTrechosPorEmpresa
})(PainelGerenciarRotas)
